import { render, staticRenderFns } from "./Dropper.vue?vue&type=template&id=61021ff4&scoped=true"
import script from "./Dropper.vue?vue&type=script&lang=js"
export * from "./Dropper.vue?vue&type=script&lang=js"
import style0 from "./Dropper.vue?vue&type=style&index=0&id=61021ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61021ff4",
  null
  
)

export default component.exports